import { useEffect } from "react";

const SITE = "https://monetizegps.com";
const DEFAULT_TITLE = "MonetizeGPS — Monetization directions for any website";
const DEFAULT_DESC =
  "MonetizeGPS — paste any URL, get the top ways to monetize it. Chrome extension + web tool.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets document title, meta description, canonical and OG/Twitter tags for a page.
 * Purely additive head management — does not affect rendering or behavior.
 */
export function usePageMeta({ title, description, path = "/" } = {}) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("name", "twitter:title", t);
    setMeta("name", "twitter:description", d);
    setCanonical(`${SITE}${path}`);
  }, [title, description, path]);
}

/** Injects a JSON-LD structured data block (removed on unmount). */
export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data]);
}
